import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-email",
  "use": "ico-email-usage",
  "viewBox": "0 0 30 23",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 23\" id=\"ico-email\">\n  <path id=\"ico-email_Path_1427\" data-name=\"Path 1427\" d=\"M3.841,5.4,14.391,9.3,26.159,5.4M1,1V22H29V1Z\" fill=\"none\" stroke=\"#737878\" stroke-linecap=\"round\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol